function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Tooltip from '../../Tips/Tooltip/Tooltip';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import IconButton from '../../Buttons/IconButton/IconButton';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import styles from './HorizontalScroll.module.scss';
import Icon from '../../Icons/Icon/Icon';
import { ReactComponent as DirectionalArrow } from '../../../icons/DirectionalArrowWithStick/DirectionalArrowWithStick.svg';
import HorizontalScrollContext from './HorizontalScrollContext';
import useDisabledScroll from './useDisabledScroll';
import ThemeContext from '../../ThemeContext';
import cs from 'classnames';
function px(number) {
  return "".concat(number, "px");
}
function style(el, styl) {
  Object.keys(styl).forEach(function (key) {
    return el.style[key] = styl[key];
  });
}
function useStickyHeader() {
  var _useContext = useContext(HorizontalScrollContext),
    sticksTo = _useContext.sticksTo,
    overflowRef = _useContext.overflowRef,
    containerRef = _useContext.containerRef;
  var leftRef = useRef();
  var rightRef = useRef();
  useEffect(function () {
    var handler = function handler() {
      var header = sticksTo ? document.querySelector(sticksTo) : undefined;
      if (header) {
        var containerEl = containerRef.current;
        var tableHeaderEl = containerEl.querySelector('.dm-table__header');
        var tableBodyEl = containerEl.querySelector('.dm-table__body');
        var hRect = header.getBoundingClientRect();
        var cRect = containerEl.getBoundingClientRect();
        var thRect = tableHeaderEl.getBoundingClientRect();
        var oRect = overflowRef.current.getBoundingClientRect();
        var clEl = leftRef.current;
        var crEl = rightRef.current;
        if (cRect.top < hRect.bottom) {
          style(tableHeaderEl, {
            position: 'fixed',
            top: px(hRect.bottom),
            width: px(cRect.width)
          });
          style(tableBodyEl, {
            paddingTop: px(thRect.height)
          });
          style(crEl, {
            display: '',
            height: px(thRect.height),
            left: px(oRect.right),
            position: 'fixed',
            top: px(hRect.bottom)
          });
          style(clEl, {
            display: '',
            position: 'fixed',
            top: px(hRect.bottom),
            height: px(thRect.height),
            width: px(oRect.left)
          });
        } else {
          style(tableHeaderEl, {
            position: '',
            top: '',
            width: ''
          });
          style(tableBodyEl, {
            paddingTop: ''
          });
          style(clEl, {
            display: 'none'
          });
          style(crEl, {
            display: 'none'
          });
        }
      }
    };
    window.addEventListener('scroll', handler, false);
    window.addEventListener('resize', handler, false);
    return function () {
      window.removeEventListener('scroll', handler);
      window.removeEventListener('resize', handler);
    };
  }, [overflowRef, containerRef, leftRef, rightRef, sticksTo]);
  return !sticksTo ? undefined : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.clip, " ").concat(styles['clip-left']),
    ref: leftRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.clip, " ").concat(styles['clip-right']),
    ref: rightRef
  }));
}
function useColumnLefts() {
  var _useContext2 = useContext(HorizontalScrollContext),
    containerRef = _useContext2.containerRef,
    overflowRef = _useContext2.overflowRef,
    stickyColumns = _useContext2.stickyColumns;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    columnLefts = _useState2[0],
    setColumnLefts = _useState2[1];
  useEffect(function () {
    var handler = function handler() {
      var overflowEl = overflowRef.current;
      var containerEl = containerRef.current;
      if (containerEl && overflowEl) {
        var headerEls = containerEl.querySelectorAll('.dm-table__cell--header');
        var left = 0;
        var lefts = Array.from(headerEls).slice(stickyColumns).map(function (el) {
          var prev = left;
          var width = el.getBoundingClientRect().width;
          left = left - width;
          return prev;
        });
        var overflowWidth = overflowEl.getBoundingClientRect().width;
        var containerWidth = containerEl.getBoundingClientRect().width;
        var maxColumn = lefts.findIndex(function (left) {
          return overflowWidth - left >= containerWidth;
        });
        if (maxColumn > 0) {
          lefts = lefts.slice(0, maxColumn);
          lefts.push(overflowWidth - containerWidth);
        }
        setColumnLefts(lefts);
      }
    };
    handler();
    window.addEventListener('resize', handler, false);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, [containerRef, overflowRef, stickyColumns]);
  return columnLefts;
}
function useColumnsScroll() {
  var context = useContext(HorizontalScrollContext);
  var containerRef = context.containerRef,
    overflowRef = context.overflowRef,
    stickyColumns = context.stickyColumns,
    tableRef = context.tableRef;
  var columnLefts = useColumnLefts({
    containerRef: containerRef,
    stickyColumns: stickyColumns
  });
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    firstColumn = _useState4[0],
    setFirstColumn = _useState4[1];
  var canScrollLeft = firstColumn !== 0;
  var handleScrollLeft = useCallback(function () {
    if (canScrollLeft) {
      setFirstColumn(firstColumn - 1);
    }
  }, [setFirstColumn, firstColumn, canScrollLeft]);
  var canScrollRight = firstColumn !== columnLefts.length - 1;
  var handleScrollRight = useCallback(function () {
    if (canScrollRight) {
      setFirstColumn(firstColumn + 1);
    }
  }, [setFirstColumn, firstColumn, canScrollRight]);
  useEffect(function () {
    var el = overflowRef.current;
    if (!el) {
      return;
    }
    var total = 0;
    var wheelHandler = function wheelHandler(e) {
      total += e.deltaX;
      if (total > 50) {
        total = 0;
        handleScrollRight();
      } else if (total < -50) {
        total = 0;
        handleScrollLeft();
      }
      if (e.deltaX !== 0) {
        var bubble = document.createEvent('MouseEvents');
        bubble.initEvent('wheel', true, true);
        bubble.deltaY = e.deltaY;
        bubble.deltaX = 0;
        el.dispatchEvent(bubble);
        e.preventDefault();
        return false;
      }
    };
    el.addEventListener('wheel', wheelHandler, false);
    return function () {
      el.removeEventListener('wheel', wheelHandler);
    };
  }, [overflowRef, handleScrollLeft, handleScrollRight]);
  context.onKeyDown = useCallback(function (e) {
    if (e.which === 37) {
      handleScrollLeft();
    }
    if (e.which === 39) {
      handleScrollRight();
    }
  }, [handleScrollLeft, handleScrollRight]);
  context.onFocus = useCallback(function (e) {
    var cell = e.target.closest('.dm-table__cell');
    if (cell) {
      overflowRef.current.scrollLeft = 0;
      var columns = tableRef.current.props.columns;
      var _loop = function _loop() {
        if (cell.classList.contains("dm-table__cell--".concat(columns[col].accessor))) {
          var index = col - stickyColumns;
          if (index < firstColumn) {
            setFirstColumn(index);
          } else {
            var right = cell.getBoundingClientRect().right;
            var overflow = overflowRef.current.getBoundingClientRect().right;
            if (right > overflow) {
              var offset = right - overflow - columnLefts[firstColumn];
              var left = columnLefts.findIndex(function (col) {
                return offset + col < 0;
              });
              setFirstColumn(left > 0 ? left : columnLefts.length - 1);
            }
          }
        }
      };
      for (var col = stickyColumns; col < columns.length; col++) {
        _loop();
      }
    }
  }, [columnLefts, overflowRef, stickyColumns, setFirstColumn, tableRef, firstColumn]);
  if (firstColumn > 0 && firstColumn >= columnLefts.length) {
    setFirstColumn(columnLefts.length - 1);
  }
  useEffect(function () {
    var el = containerRef.current;
    var tableEl = tableRef.current;
    if (el && tableEl) {
      var columns = tableEl.props.columns;
      el.style.left = "".concat(columnLefts[firstColumn], "px");
      for (var col = 0; col < stickyColumns; col++) {
        Array.from(el.querySelectorAll(".dm-table__cell--".concat(columns[col].accessor))).forEach(function (colEl) {
          colEl.classList.add(styles['sticky-column']);
          colEl.style.left = "".concat(-columnLefts[firstColumn], "px");
        });
      }
    }
  }, [tableRef, containerRef, firstColumn, columnLefts, stickyColumns]);
  var style = useMemo(function () {
    if (tableRef.current) {
      var columns = tableRef.current.props.columns;
      return /*#__PURE__*/React.createElement("style", null, columns.slice(stickyColumns).map(function (col, index) {
        if (index < firstColumn) {
          return ".dm-table__cell--".concat(col.accessor, " { opacity: 0 }");
        } else {
          return ".dm-table__cell--".concat(col.accessor, " { opacity: 100% }");
        }
      }));
    }
  }, [firstColumn, tableRef, stickyColumns]);
  return {
    canScrollLeft: canScrollLeft,
    canScrollRight: canScrollRight,
    handleScrollLeft: handleScrollLeft,
    handleScrollRight: handleScrollRight,
    style: style
  };
}
function Controls(_ref) {
  var canScrollLeft = _ref.canScrollLeft,
    canScrollRight = _ref.canScrollRight,
    leftLabelI18nKey = _ref.leftLabelI18nKey,
    leftTooltipI18nKey = _ref.leftTooltipI18nKey,
    onScrollLeft = _ref.onScrollLeft,
    onScrollRight = _ref.onScrollRight,
    rightLabelI18nKey = _ref.rightLabelI18nKey,
    rightTooltipI18nKey = _ref.rightTooltipI18nKey;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles['button-container'], styles[theme])
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: leftTooltipI18nKey
  }, function (_ref2) {
    var ref = _ref2.ref,
      labelledby = _ref2.labelledby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(IconButton, Object.assign({
      className: "".concat(styles['scroll'], " ").concat(!canScrollLeft && styles['disabled'], " auto-scroll-left"),
      ref: ref,
      "aria-labelledby": labelledby
    }, events, {
      onClick: onScrollLeft,
      disabled: !canScrollLeft
    }), /*#__PURE__*/React.createElement(Icon, {
      width: 14,
      height: 14,
      className: styles.icon
    }, /*#__PURE__*/React.createElement(DirectionalArrow, {
      width: 14,
      height: 14
    })), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: leftLabelI18nKey,
      hideLabel: true
    }));
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.divider
  }, "|"), /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: rightTooltipI18nKey
  }, function (_ref3) {
    var ref = _ref3.ref,
      labelledby = _ref3.labelledby,
      events = _ref3.events;
    return /*#__PURE__*/React.createElement(IconButton, Object.assign({
      className: "".concat(styles['scroll'], " ").concat(!canScrollRight && styles['disabled'], " auto-scroll-right"),
      ref: ref,
      "aria-labelledby": labelledby
    }, events, {
      onClick: onScrollRight,
      disabled: !canScrollRight
    }), /*#__PURE__*/React.createElement(Icon, {
      width: 14,
      height: 14,
      className: "".concat(styles.icon, " ").concat(styles.right)
    }, /*#__PURE__*/React.createElement(DirectionalArrow, {
      width: 14,
      height: 14
    })), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: rightLabelI18nKey,
      hideLabel: true
    }));
  }));
}
function EnabledHorizontalScroll(_ref4) {
  var leftEndTooltipI18nKey = _ref4.leftEndTooltipI18nKey,
    leftLabelI18nKey = _ref4.leftLabelI18nKey,
    rightEndTooltipI18nKey = _ref4.rightEndTooltipI18nKey,
    rightLabelI18nKey = _ref4.rightLabelI18nKey;
  var stickyChildren = useStickyHeader();
  var _useColumnsScroll = useColumnsScroll(),
    style = _useColumnsScroll.style,
    canScrollLeft = _useColumnsScroll.canScrollLeft,
    canScrollRight = _useColumnsScroll.canScrollRight,
    handleScrollLeft = _useColumnsScroll.handleScrollLeft,
    handleScrollRight = _useColumnsScroll.handleScrollRight;
  return /*#__PURE__*/React.createElement(React.Fragment, null, style, stickyChildren, /*#__PURE__*/React.createElement(Controls, {
    canScrollLeft: canScrollLeft,
    canScrollRight: canScrollRight,
    leftLabelI18nKey: leftLabelI18nKey,
    leftTooltipI18nKey: canScrollLeft ? leftLabelI18nKey : leftEndTooltipI18nKey,
    onScrollLeft: handleScrollLeft,
    onScrollRight: handleScrollRight,
    rightLabelI18nKey: rightLabelI18nKey,
    rightTooltipI18nKey: canScrollRight ? rightLabelI18nKey : rightEndTooltipI18nKey
  }));
}
function DisabledHorizontalScroll(_ref5) {
  var leftDisabledTooltipI18nKey = _ref5.leftDisabledTooltipI18nKey,
    rightDisabledTooltipI18nKey = _ref5.rightDisabledTooltipI18nKey,
    leftLabelI18nKey = _ref5.leftLabelI18nKey,
    rightLabelI18nKey = _ref5.rightLabelI18nKey;
  return /*#__PURE__*/React.createElement(Controls, {
    canScrollLeft: false,
    canScrollRight: false,
    leftLabelI18nKey: leftLabelI18nKey,
    leftTooltipI18nKey: leftDisabledTooltipI18nKey,
    rightLabelI18nKey: rightLabelI18nKey,
    rightTooltipI18nKey: rightDisabledTooltipI18nKey
  });
}
export default function HorizontalScroll(_ref6) {
  var leftDisabledTooltipI18nKey = _ref6.leftDisabledTooltipI18nKey,
    rightDisabledTooltipI18nKey = _ref6.rightDisabledTooltipI18nKey,
    leftEndTooltipI18nKey = _ref6.leftEndTooltipI18nKey,
    leftLabelI18nKey = _ref6.leftLabelI18nKey,
    rightEndTooltipI18nKey = _ref6.rightEndTooltipI18nKey,
    rightLabelI18nKey = _ref6.rightLabelI18nKey;
  var disabled = useDisabledScroll();
  return disabled ? /*#__PURE__*/React.createElement(DisabledHorizontalScroll, {
    leftDisabledTooltipI18nKey: leftDisabledTooltipI18nKey,
    rightDisabledTooltipI18nKey: rightDisabledTooltipI18nKey,
    leftLabelI18nKey: leftLabelI18nKey,
    rightLabelI18nKey: rightLabelI18nKey
  }) : /*#__PURE__*/React.createElement(EnabledHorizontalScroll, {
    leftEndTooltipI18nKey: leftEndTooltipI18nKey,
    leftLabelI18nKey: leftLabelI18nKey,
    rightEndTooltipI18nKey: rightEndTooltipI18nKey,
    rightLabelI18nKey: rightLabelI18nKey
  });
}